import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

interface ReportingActiveStudentsClassCountParams {
  format?: string;
  locationId: string;
}

export const reportingActiveStudentsClassCountAPI = async (
  params?: ReportingActiveStudentsClassCountParams,
) => {
  const response = await baseAPI.get<string>(
    'reporting/active-students-class-count',
    {
      params,
      responseType: 'text',
    },
  );
  return response.data;
};

export const useReportingActiveStudentsClassCount = (
  params?: ReportingActiveStudentsClassCountParams,
) => {
  return useQuery({
    queryKey: [KEYS.ACTIVE_STUDENTS_CLASS_COUNT_REPORT, params],
    queryFn: () => reportingActiveStudentsClassCountAPI(params),
    enabled: !!params?.format,
  });
};
